export default "./dist/stdassets/cursors/digitizeLine.cur";